import {BaseApp} from '@genstackio/react-admin-core';
import * as config from './configs';
import useApp from "@genstackio/react-admin-core/lib/hooks/useApp";

function App() {
    return <BaseApp {...useApp(config)} />;
}

export default App